// import package
import React, { Component, Fragment } from "react";
import { Modal, Button } from 'react-bootstrap';
import classnames from "classnames";

// import action
import { approveFiatDeposit, rejectFiatDeposit } from '../../actions/walletAction';
import { capitalize } from '../../lib/capitalize'
// import lib
import { toastAlert } from '../../lib/toastAlert';

const initialFormValue = {
    'amount': '',
    message: "",
}


class FiatDepositModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formValue: initialFormValue,
            errors: {},
            loader: false
        };
    }

    handleChange = e => {
        e.preventDefault();
        let { name, value } = e.target;
        let formData = { ...this.state.formValue, ...{ [name]: value } };
        this.setState({ formValue: formData });
    }

    handleSubmit = async e => {
        e.preventDefault();
        try {
            const { record, fetchData } = this.props;
            const { formValue } = this.state;
            let reqData = {
                'transactionId': record._id,
                'amount': formValue.amount
            };

            const { status, loading, message, error } = await approveFiatDeposit(reqData);
            if (status == 'success') {
                fetchData();
                toastAlert('success', message, 'fiatDeposit');
                this.handleClose()
            } else {
                if (error) {
                    console.log("errorerrorerrorerror", error, message)
                    this.setState({ errors: error })
                }
                toastAlert('error', message, 'fiatDeposit');
            }
        } catch (err) { }
    }
    handleSubmitReject = async e => {
        e.preventDefault();
        try {
            const { record, fetchData } = this.props;
            const { formValue } = this.state;
            let reqData = {
                'transactionId': record._id,
                message: formValue.message,
                'amount': formValue.amount
            };

            const { status, loading, message, error } = await rejectFiatDeposit(reqData);
            if (status == 'success') {
                fetchData();
                toastAlert('success', message, 'fiatDeposit');
                this.handleClose()
            } else {
                if (error) {
                    console.log("errorerrorerrorerror", error, message)
                    this.setState({ errors: error })
                }
                toastAlert('error', message, 'fiatDeposit');
            }
        } catch (err) { }
    }
    handleClose = () => {
        const { onHide } = this.props;
        onHide();
    }

    render() {
        const { isShow, record, loader } = this.props;
        const { amount, message } = this.state.formValue;
        const { errors } = this.state;

        return (
            <Modal
                show={isShow}
                onHide={this.handleClose}
                size="lg"
                centered
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="popUpSpace">
                        {
                            record.status == "completed" && <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="answer">Transaction ID</label>
                                </div>
                                <div className="col-md-9">
                                    {record.txid?record.txid:record._id}
                                </div>
                            </div>
                        }

                        <div className="row mt-2">
                            <div className="col-md-3">
                                <label htmlFor="answer">Deposit Amount</label>
                            </div>
                            <div className="col-md-9">
                                {record.amount}
                            </div>
                        </div>

                        {
                            record.status != 'pending' && <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="answer">Deposited Amount</label>
                                </div>
                                <div className="col-md-9">
                                    {record.actualAmount}
                                </div>
                            </div>
                        }


                        <div className="row mt-2">
                            <div className="col-md-3">
                                <label htmlFor="answer">Document</label>
                            </div>
                            <div className="col-md-9">
                                <a href={record.image} target="_blank"> <img src={record.image} width="100" height="100" /></a>
                            </div>
                        </div>


                        {
                            record.status == 'pending' && <>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <label htmlFor="answer">Deposit Amount</label>
                                    </div>
                                    <div className="col-md-9">
                                        <input
                                            type="number"
                                            name="amount"
                                            value={amount}
                                            onChange={this.handleChange}
                                            error={errors.amount}
                                            className={classnames("form-control", {
                                                invalid: errors.amount
                                            })}
                                        />
                                        <span className="text-danger">{errors.amount}</span>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <label htmlFor="answer">Reason</label>
                                    </div>
                                    <div className="col-md-9">

                                        <input
                                            type="text"
                                            name="message"
                                            value={message}
                                            onChange={this.handleChange}
                                            error={errors.message}
                                            className={classnames("form-control", {
                                                invalid: errors.message,
                                            })}
                                        />
                                        <span className="text-danger">{errors.message}</span>

                                    </div>
                                </div>
                            </>
                        }
                        {
                            record.status == 'rejected' && record.message &&
                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="answer">Reason</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        type="text"
                                        name="message"
                                        value={record.message}
                                        disabled={true}
                                        className={classnames("form-control", {
                                            invalid: errors.amount
                                        })}
                                    />
                                </div>
                            </div>


                        }

                        <div className="row mt-2">
                            <div className="col-md-3">
                                <label htmlFor="answer">Status</label>
                            </div>
                            <div className="col-md-9">
                                {capitalize(record.status)}
                            </div>
                        </div>

                    </div>
                </Modal.Body>
                {
                    record.status == 'pending' && <Modal.Footer>
                        <Button
                            onClick={this.handleSubmit}
                            variant="success btnDefaultNew"
                            disabled={loader}
                        >
                            Confirm
                        </Button>
                        <Button
                            onClick={this.handleSubmitReject}
                            variant="danger btnDefaultNew"
                            disabled={loader}
                        >
                            Reject
                        </Button>
                    </Modal.Footer>
                }

            </Modal>
        )
    }
}

export default FiatDepositModal;